<template>
  <v-bottom-sheet
    v-model="modelValue"
    :fullscreen="fullscreen"
    @click:outside="close()"
  >
    <v-expand-transition>
      <v-sheet
        color="neutral"
        class="text-center relative pa-4 pt-8"
        :class="{ 'sheet-radius': !fullscreen }"
        :height="
          fullscreen
            ? '100%'
            : $vuetify.breakpoint.smAndUp
            ? '25rem'
            : '22.5rem'
        "
      >
        <v-btn
          class="btn-icon"
          color="white"
          icon
          absolute
          top
          right
          @click="close()"
        >
          <v-icon> fa-solid fa-arrow-down </v-icon>
        </v-btn>

        <slot />
      </v-sheet>
    </v-expand-transition>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: "BottomPopup",

  props: {
    value: {
      type: Boolean,
      required: true,
    },

    fullscreen: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update:value", newValue);
      },
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
